$(document).ready(function () {
  $('#gusSearchBtn').on('click', function() {
    const nip = $('input[name="nip"]').val();
    const token = $('input[name="csrf_token"]').val();
    
    const normalizeValue = (value) => {
      if (typeof value !== 'string') {
        return value;
      }

      return value.trim();
    };

    const fillGusFields = (response) => {
      const normalizedResponse = {
        ...response,
        city: response.city || response.postCity || '',
        post_code: response.post_code || response.postCode || ''
      };

      Object.entries(normalizedResponse).forEach(([fieldName, fieldValue]) => {
        const normalizedValue = normalizeValue(fieldValue);

        if (typeof normalizedValue === 'undefined' || normalizedValue === null || normalizedValue === '') {
          return;
        }

        const $field = $(`input[gus-field="${fieldName}"]`);

        if ($field.length) {
          $field.val(normalizedValue);
        }
      });
    };

    $('#gusSearchBtn').attr('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/ax_cart',
      dataType: 'json',
      data: {
        action: "getInvoiceData",
        nip: nip,
        csrf_token: token
      },
      success: function(response) {
        console.log("🚀 ~ response:", response)
        $('#gusSearchBtn').attr('disabled', false);

        if(response === null || typeof response.name === 'undefined'){
          $('input[name="nip"]').addClass('input-error');
          return;
        }

        fillGusFields(response);
      },
      error: function() {
        $('input[name="nip"]').addClass('input-error');
        $('#gusSearchBtn').attr('disabled', false);
      }
    });
  });
});